import React from 'react';
import { History } from 'history';
import { usePostApi } from 'api/post/usePostApi';
import { NewsDetailsComponent } from 'containers/user-interface/Public/News/Details';
import { useParams } from 'react-router-dom';
import { parseIdFromSeoname } from 'helpers/commonUtils';
import { useListPostPublic } from 'api/post/usePostApi/useListPostPublic';

export const NewsDetailsContainer = (props: { history: History }) => {
  const { seoname } = useParams<{ seoname: string }>();
  const {
    get: { getPost, error, post, loading },
  } = usePostApi();

  const { posts } = useListPostPublic();

  const newsId = parseIdFromSeoname(seoname);

  React.useEffect(() => {
    if (newsId) {
      getPost({ id: newsId });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newsId]);

  return (
    <NewsDetailsComponent
      isLoading={loading}
      error={error}
      news={post}
      history={props.history}
      recentNews={posts.filter((news) => news.id !== newsId)}
    />
  );
};

export default NewsDetailsContainer;
